import { render, staticRenderFns } from "./affirmJumpstart.vue?vue&type=template&id=2685c396&scoped=true&"
import script from "./affirmJumpstart.vue?vue&type=script&lang=js&"
export * from "./affirmJumpstart.vue?vue&type=script&lang=js&"
import style0 from "./affirmJumpstart.vue?vue&type=style&index=0&id=2685c396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2685c396",
  null
  
)

export default component.exports